import * as types from './types';
import { retrieveMSRP, saveMSRP } from 'src/utils/persistence';

/* state shape
MSRPState {
  showOnlyMSRP: false
} */

const savedMSRP = retrieveMSRP();

const showOnlyMSRP: boolean = savedMSRP == null ? false : savedMSRP;

const MSRPReducerDefaultState = { showOnlyMSRP };

const MSRPReducer = (state = MSRPReducerDefaultState, action: any) => {
  switch (action.type) {
    case types.TOGGLE_MSRP:
      saveMSRP(!state.showOnlyMSRP);
      return { showOnlyMSRP: !state.showOnlyMSRP };
    default:
      return state;
  }
};

export default MSRPReducer;
